<template>
  <div>
    <v-card 
      class="mt-4"
    >
      <v-card-title>
          <v-text-field
              v-model="buscarAcciones"
              append-icon="mdi-file-search-outline"
              label="Buscar"
              single-line
              hide-details
          ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headersFidelizaciones"
        :items="parte.fidelizaciones"
        :search="buscarAcciones"
        sort-by="estado"
        multi-sort
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Fidelizaciones</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              @click="insertarAccion()"
              :disabled="parte.bloqueado || !tienePermisosEnComponenteId(14)"
            >
              Nueva fidelización
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.solicitada_por.name="{ item }">
          <v-chip outlined>
            <v-avatar left :color="item.solicitada_por.color">
              <span class="white--text">
                {{ item.solicitada_por.avatar }}
              </span>
            </v-avatar>
            {{ item.solicitada_por.name }}
          </v-chip>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-chip outlined>
            <v-avatar left :color="item.user.color">
              <span class="white--text">
                {{ item.user.avatar }}
              </span>
            </v-avatar>
            {{ item.user.name }}
          </v-chip>
        </template>
        <template v-slot:item.tipoFidelizacion_id="{ item }">
          <v-select
            v-model="item.tipoFidelizacion_id"
            :items="tiposFidelizaciones"
            item-text="nombre"
            item-value="id"
            readonly
          ></v-select>
        </template>
        <template v-slot:item.descripcion="{ item }">
          <v-textarea
            v-model="item.descripcion"
            readonly
            hide-details
            rows="1"
          ></v-textarea>
        </template>
        <template v-slot:item.comentarios="{ item }">
          <v-textarea
            v-model="item.comentarios"
            readonly
            hide-details
            rows="1"
          ></v-textarea>
        </template>
        <template v-slot:item.fechaFidelizacion="{ item }">
          {{ formatDate(item.fechaFidelizacion) }}
        </template>
        <template v-slot:item.estado="{ item }">
          <v-checkbox
            v-model="item.estado"
            disabled
          ></v-checkbox>
        </template>
        <template v-slot:item.acciones="{ item }">
            <v-icon
                class="mr-2"
                @click="editarAccion(item)"
            >
                mdi-file-document-edit-outline
            </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAccion" persistent max-width="800px">
        <v-card>
          <v-card-title class="headline">
            {{ tituloDialogAccion }} 
            <v-spacer></v-spacer>
            <h6 style="font-weight: normal;" v-if="accion.modificada !== true && accion.estado && accion.fechaCompletada">Completada el {{ accion.fechaCompletada }}</h6>
          </v-card-title>
          <v-card-text>
            <v-alert
              dense
              outlined
              border="left"
              type="warning"
              icon="mdi-alert-outline"
              v-if="!accion.esEditable"
            >
              No tienes permisos para editar esta fidelización.
            </v-alert>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="accion.user"
                  :items="usuarios"
                  chips
                  color="blue-grey lighten-2"
                  label="Asignada a"
                  item-text="name"
                  item-value="id"
                  @input="$v.accion.user.$touch()"
                  @blur="$v.accion.user.$touch()"
                  :error-messages="errorUsuarioAsignado"
                  return-object
                  :disabled="parte.bloqueado || accion.estado || !accion.esEditable"
                  class="anadirAsterisco"
                >
                  <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                  >
                    <v-avatar left :color="data.item.color">
                    <span class="white--text">{{ data.item.avatar }}</span>
                    </v-avatar>
                    {{ data.item.name + " " + data.item.apellidos }}
                  </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar :color="data.item.color">
                        <span class="white--text">{{ data.item.avatar }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.apellidos }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  v-model="accion.tipoFidelizacion_id"
                  label="Tipo de fidelización"
                  :items="tiposFidelizaciones"
                  item-text="nombre"
                  item-value="id"
                  @input="$v.accion.tipoFidelizacion_id.$touch()"
                  @blur="$v.accion.tipoFidelizacion_id.$touch()"
                  :error-messages="errorTipoFidelizacion"
                  :disabled="parte.bloqueado || accion.estado || !accion.esEditable"
                  class="anadirAsterisco"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="fecha" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field 
                      v-model="fechaFormateada" 
                      label="Fecha fidelizacion" v-bind="attrs" 
                      v-on="on" 
                      @blur="fecha = parseDate(fechaFormateada)" 
                      readonly
                      :disabled="parte.bloqueado || accion.estado || accion.alFinalizarParte == 1 || !accion.esEditable"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha" scrollable :first-day-of-week="1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialogFecha.save(fecha)">Aceptar</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="accion.alFinalizarParte"
                  label="Al finalizar el parte"
                  :disabled="parte.bloqueado || accion.estado || !accion.esEditable"
                  @change="alFinalizarParte(accion)"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Descripción"
                  v-model="accion.descripcion"
                  no-resize
                  @input="$v.accion.descripcion.$touch()"
                  @blur="$v.accion.descripcion.$touch()"
                  :error-messages="errorDescripcion"
                  :disabled="parte.bloqueado || accion.estado || !accion.esEditable"
                  class="anadirAsterisco"
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Comentarios"
                  v-model="accion.comentarios"
                  no-resize
                  :disabled="parte.bloqueado || accion.estado || !accion.esEditable"
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" block outlined>
                      Más opciones
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-title class="px-2">
                        <v-checkbox
                          v-model="accion.estado"
                          label="Marcar acción como completada"
                          :disabled="parte.bloqueado || !accion.esEditable"
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              v-if="editando" 
              color="error" 
              text 
              @click="dialogEliminar = true"
              :disabled="parte.bloqueado || !accion.esEditable"
            >
              Eliminar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogAccion = false; $v.$reset();">Cancelar</v-btn>
            <v-btn 
              text 
              @click="aceptarAccion()"
              :disabled="$v.accion.$invalid || parte.bloqueado || !accion.esEditable"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEliminar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a eliminar esta acción. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="eliminarAccion(accion)">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogFidelizacionesCompletadas" persistent max-width="550">
        <v-card>
          <v-card-title class="headline">Acciones de fidelización completadas</v-card-title>
          <v-card-text>
            Actualmente el parte está en estado "Pendiente de fidelizar" pero todas las acciones de fidelización están completadas.
            <br>
            ¿Quieres marcar el parte como "Finalizado"?
            <br>
            Si decides no finalizarlo, cambiará a estado "Activo".
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="parte.estadoParte_id = 1; dialogFidelizacionesCompletadas = false">Cancelar</v-btn>
            <v-btn color="success" text @click="parte.estadoParte_id = 3; dialogFidelizacionesCompletadas = false">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
  
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import formatearFecha from '../../mixins/formatearFecha';
  import getArrayPositionByItemId from '../../mixins/getArrayPositionByItemId';
  import uuidv4 from '../../mixins/uuidv4';
  import { required } from 'vuelidate/lib/validators';
  export default {
    name: 'Fidelizaciones',
    mixins: [formatearFecha, getArrayPositionByItemId, uuidv4],
    props: ['parte', 'usuarios'],
    data () {
        return {
          dialogAccion: false,
          dialogEliminar: false,
          dialogFidelizacionesCompletadas: false,
          headersFidelizaciones: [
            {
              text: 'Solicitada por',
              align: 'start',
              filterable: true,
              sortable: true,
              value: 'solicitada_por.name'
            },
            {
              text: 'Tipo',
              filterable: true,
              sortable: true,
              value: 'tipoFidelizacion_id',
            },
            {
              text: 'Descripción',
              filterable: true,
              sortable: false,
              value: 'descripcion',
            },
            {
              text: 'Asignada a',
              filterable: true,
              sortable: true,
              value: 'user.name',
            },
            {
              text: 'Fecha fidelización',
              filterable: true,
              sortable: true,
              value: 'fechaFidelizacion'
            },
            {
              text: 'Finalizada',
              filterable: true,
              sortable: true,
              value: 'estado',
            },
            {
              text: '',
              filterable: false,
              sortable: false,
              value: 'acciones'
            },
          ],
          accion: {},
          buscarAcciones: '',
          editando: false,
          tituloDialogAccion: '',
          tiposFidelizaciones: [
            {
              id: 1,
              nombre: 'Necesidad de cliente'
            },
            {
              id: 2,
              nombre: 'Petición interna'
            },
            {
              id: 3,
              nombre: 'Llamada de fidelización'
            },
            {
              id: 4,
              nombre: 'Email de fidelización'
            },
            {
              id: 5,
              nombre: 'Otros'
            },
          ],
          fechaFormateada: null,
          fecha: 'null',
          modalFecha: false
        }
    },
    validations: {
      accion: {
        user: { required },
        tipoFidelizacion_id: { required },
        descripcion: { required }
      }
    },
    methods: {
      ...mapActions('partes', ['setDialog']),
      ...mapActions(['setLoading', 'setSnackbar']),
      avisoCerrar(){
        this.dialogCerrar = true;
      },
      cerrar(){
        this.dialogCerrar = false;
        this.setDialog(false);
      },
      insertarAccion(){
        this.inicializarFecha(true);
        this.accion = {
          id: this.uuidv4(),
          estado: false,
          tipoFidelizacion_id: 1,
          fechaFidelizacion: this.fecha,
          alFinalizarParte: false,
          esEditable: true,
        };
        
        this.editando = false;
        this.tituloDialogAccion = 'Nueva fidelización';
        this.dialogAccion = true;
      },
      aceptarAccion(){
        this.accion.solicitada_por = this.authUser;
        if(this.editando){
          let posicionArray = this.getArrayPositionByItemId(this.parte.fidelizaciones, this.accion.id);
          let accion = this.parte.fidelizaciones[posicionArray];
          accion.user = this.accion.user;
          accion.tipoFidelizacion_id = this.accion.tipoFidelizacion_id;
          accion.descripcion = this.accion.descripcion;
          accion.estado = this.accion.estado;
          accion.comentarios = this.accion.comentarios;
          accion.fechaFidelizacion = this.fecha;
          accion.modificada = true;
          accion.alFinalizarParte = this.accion.alFinalizarParte;
          this.parte.fidelizacionesModificadas.push(this.accion);
        }else{
          this.accion.fechaFidelizacion = this.fecha;
          this.parte.fidelizaciones.push(this.accion);
        }
        this.checkEstadoFidelizaciones();
        this.$v.$reset();
        this.dialogAccion = false;
      },
      editarAccion(accion){
        this.accion = {
          id: accion.id,
          user: accion.user,
          tipoFidelizacion_id: accion.tipoFidelizacion_id,
          descripcion: accion.descripcion,
          estado: accion.estado,
          comentarios: accion.comentarios,
          fechaFidelizacion: accion.fechaFidelizacion,
          modificada: accion.modificada,
          alFinalizarParte: accion.alFinalizarParte,
          esEditable: accion.esEditable
        };
        if(accion.updated_at){
          this.accion.fechaCompletada = this.formatearFecha(accion.updated_at);
        }
        
        this.fecha = this.accion.fechaFidelizacion;
        this.tituloDialogAccion = 'Editar fidelización';
        this.editando = true;
        this.dialogAccion = true;
      },
      eliminarAccion(accion){
        let posicionArray = this.getArrayPositionByItemId(this.parte.fidelizaciones, accion.id);
        this.parte.fidelizacionesEliminadas.push(accion);
        this.parte.fidelizaciones.splice(posicionArray, 1);
        this.dialogEliminar = false;
        this.dialogAccion = false;
        this.checkEstadoFidelizaciones();
      }, 
      inicializarFecha(sumarSemana){
        let fecha = new Date();
        if(sumarSemana){
          fecha.setDate(fecha.getDate() + 7)
        }
        this.fechaFormateada = this.formatDate(fecha.toISOString().substr(0, 10));
        
        this.fecha = this.parseDate(this.fechaFormateada);
      },
      alFinalizarParte(accion) {
        if (accion.alFinalizarParte) {
          this.fecha = null;
          accion.fechaFidelizacion = null;
        }else{
          if(accion.fecha === null || !accion.fecha){
            this.inicializarFecha(false);
          }
        }
      },
      checkEstadoFidelizaciones(){
        console.log(this.parte.estadoParte_id);
        console.log(this.parte.fidelizaciones);
        let fidelizacionesPendientes = this.parte.fidelizaciones.filter(fidelizacion => fidelizacion.estado === false);
        console.log(fidelizacionesPendientes)
        if(!fidelizacionesPendientes.length > 0 && this.parte.estadoParte_id === 2){ // No quedan acciones pendiente de fidelizar y el estado del parte es Pendiente de fidelizar
          this.dialogFidelizacionesCompletadas = true;
        }
      }
    },
    computed: {
      ...mapState('partes', ['dialog']),
      ...mapState('login', ['authUser']),
      ...mapGetters({
        tienePermisosEnComponenteId : "login/tienePermisosEnComponenteId"
      }),
      errorUsuarioAsignado () {
        if (this.$v.accion.user.$dirty){
          if (this.$v.accion.user.$invalid){
            return 'Introduce el usuario al que se le asignará la tarea';
          }
        }
      },
      errorTipoFidelizacion () {
        if (this.$v.accion.tipoFidelizacion_id.$dirty){
          if (this.$v.accion.tipoFidelizacion_id.$invalid){
            return 'Selecciona de la lista un tipo de fidelización';
          }
        }
      },
      errorDescripcion () {
        if (this.$v.accion.descripcion.$dirty){
          if (this.$v.accion.descripcion.$invalid){
            return 'Indica una descripción para la tarea';
          }
        }
      }
    },
    watch: {
      fecha (val) {
        this.fechaFormateada = this.formatDate(this.fecha)
      },
      "parte.estadoParte_id"(){
        if(this.parte.estadoParte_id === 2){
          this.parte.fidelizaciones.forEach(fidelizacion => {
            if((fidelizacion.alFinalizarParte === 1 || fidelizacion.alFinalizarParte === true) && fidelizacion.fechaFidelizacion === null){
              let fecha = this.formatDate(new Date().toISOString().substr(0, 10));
              fidelizacion.fechaFidelizacion = this.parseDate(fecha);
            }
          });
        }
      },
    },
  }
</script>